import Main from "@root/Main";
import {
  ComponentDefineDic,
  ComponentElem,
  PopupDefineDic,
} from "@components/interfaces";
import Components from "@components/Compoents";
import Popups from "../popups/Popups";
import page_data_schema from "@schema/marketing/page-data.json";
import ApiProxy from "../../ts/ApiProxy";
import MarketingCoupon from "./MarketingCoupon";
import PromoteList from "../ui/PromoteList";
import MarketingNav from "./MarketingNav";

let _componentDic: ComponentDefineDic = {
  "marketing-coupon": MarketingCoupon,
  "promote-list": PromoteList,
  "marketing-nav": MarketingNav,
};

let _popupDic: PopupDefineDic = {};

let $root: JQuery;

Main.preInitPage = () => {
  ApiProxy.validatePageData("page-data", page_data_schema);
  // ApiProxy.logPageData();
};

Main.initPage = () => {
  $root = $("#page-content");
  // console.log(ApiProxy.getPageData());
  // new ImageSlider($root.find(`[component="image-slider"]`)[0] as ComponentElem);
};

function setupCoupons() {
  let pageData = ApiProxy.getPageData() as SkbankOmniU.PageData;

  let $coupons = $root.find(".coupons").empty();
  pageData.coupons.forEach((data) => {
    let coupon = new MarketingCoupon(MarketingCoupon.$sample.clone()[0], data);
    $coupons.append(coupon.$root);
  });
}

Components.registComponents(_componentDic);
Popups.registComponents(_popupDic);

export namespace SkbankOmniU {
  export type PageData = {
    coupons: Coupon[];
  };

  export type Coupon = {
    coupon_marketing_id: string;
    coupon_class_id: string;
    title: string;
    name: string;
    is_help_exist?: boolean;
    is_obtained?: boolean;
  };
}
